<template>
  <div class="equipment">
    <NewPie :id="chartId" :option="activeOption" :bg="bgColor" :echartData="activeData" ref="changePie"></NewPie>
  </div>
</template>

<script>
import NewPie from '@/components/newPie/newPie.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    chartId: {
      type: String,
    },
    echartData: {
      type: Array,
    },
    seriesSize: {
      type: Number,
    },
    legendY: {
      type: Number,
    },
  },
  components: {
    NewPie,
  },
  data() {
    return {
      bgColor: '',
      Color: '',
      activeData: this.echartData,
      activeOption: {
        chart: {
          type: 'pie', //饼图
          backgroundColor: null,
          options3d: {
            enabled: true, //使用3d功能
            alpha: 60, //延y轴向内的倾斜角度
            beta: 0,
          },
        },
        title: {
          text: '', //图表的标题文字
        },
        subtitle: {
          text: '', //副标题文字
        },
        plotOptions: {
          pie: {
            showInLegend: true, //是否显示图例
            allowPointSelect: true, //每个扇块能否选中
            cursor: 'pointer', //鼠标指针
            depth: 35, //饼图的厚度
            colors: ['#2096FF', '#FFD96A', '#3CFFC4'],
            dataLabels: {
              enabled: true, //是否显示饼图的线形tip
              color: '',
              distance: 10,
              softConnector: false, //锐角的线条
              connectorShape: 'fixedOffset',
              crookDistance: '1%',
              useHTML: true,
              formatter: function(param) {
                // console.log('this.point',param,this.point)
                return this.point.name + ': <br/>' + this.percentage.toFixed(1) + '%'
              },
            },
          },
        },
        credits: {
          enabled: false, // 禁用版权信息
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          icon: 'circle',
          symbolHeight: 10,
          symbolWidth: 5,
          y: this.legendY,
          itemStyle: {
            color: '',
            fontSize: 12,
          },
        },
        series: [
          {
            type: 'pie',
            size: this.seriesSize,
            name: '', //统一的前置词,非必须
            data: this.echartData,
          },
        ],
      },
    }
  },
  methods: {
    // 切换主题 图标的颜色要重新刷新
    getChartColor() {
      if (this.isDefaultTheme) {
        this.bgColor = true
      } else {
        this.bgColor = false
      }
    },
    updated(newVal) {
      this.activeData = this.echartData
      this.activeOption.series[0].data = newVal
      this.$refs.changePie.initChart()
    },
  },
  created() {
    this.getChartColor()
  },
  watch: {
    getTheme(val) {
      this.getChartColor(val)
    },
    echartData: function(newVal) {
      this.updated(newVal)
    },
    seriesSize() {
      this.$refs.changePie.initChart()
    },
  },
  computed: {
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.equipment
  height: 100%
</style>
